<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/ImageUpload/NewDImageUploadEditor'
export default {
  name: 'NewDSingleImageEditor',
  extends: compoment
}
</script>
